import { Link } from "react-router-dom";
import { useScrollAnimation } from "../../../hooks/useScrollAnimation";

const projects = [
  {
    title: "Bright Smiles Dental",
    category: "Healthcare",
    result: "+410% Google traffic",
    img: "https://public.readdy.ai/ai/img_res/899ea00390e56d57616ff0bba8f60e1d.jpg",
  },
  {
    title: "Ironwood Builders",
    category: "Construction",
    result: "3x more quote requests",
    img: "https://readdy.ai/api/search-image?query=modern%20construction%20company%20website%20mockup%2C%20bold%20dark%20design%20with%20strong%20typography%2C%20professional%20contractor%20website%2C%20laptop%20screen%20display%2C%20neutral%20desk%20background%2C%20warm%20studio%20lighting&width=600&height=440&seq=portfolio-002&orientation=landscape",
  },
  {
    title: "The Bloom Studio",
    category: "Retail & E-commerce",
    result: "+220% online sales",
    img: "https://readdy.ai/api/search-image?query=beautiful%20florist%20shop%20website%20on%20laptop%20mockup%2C%20elegant%20pink%20and%20white%20floral%20branding%2C%20e-commerce%20product%20layout%2C%20clean%20airy%20design%2C%20soft%20studio%20light%2C%20white%20background&width=600&height=440&seq=portfolio-003&orientation=landscape",
  },
];

export default function PortfolioPreview() {
  const { ref, visible } = useScrollAnimation();

  return (
    <section className="section-pad bg-white" ref={ref}>
      <div className="container-md">
        <div
          className={`flex flex-col md:flex-row md:items-end justify-between gap-4 mb-12 transition-all duration-700 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <div>
            <span className="text-accent text-xs font-semibold uppercase tracking-[0.2em] mb-4 block">
              Our work
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-zinc-900">
              Recent case studies
            </h2>
          </div>
          <Link
            to="/portfolio"
            className="whitespace-nowrap inline-flex items-center gap-2 text-accent font-semibold hover:gap-3 transition-all duration-200 cursor-pointer text-sm"
          >
            View all work
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line" />
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {projects.map((p, i) => (
            <Link
              key={p.title}
              to="/portfolio"
              className={`group block rounded-2xl overflow-hidden cursor-pointer transition-all duration-500 hover:-translate-y-1 ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
              }`}
              style={{ transitionDelay: `${i * 120}ms` }}
            >
              {/* Image */}
              <div className="relative w-full h-52 overflow-hidden bg-zinc-100">
                <img
                  src={p.img}
                  alt={`${p.title} website design case study`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                  <span className="text-white text-sm font-medium flex items-center gap-2">
                    View case study
                    <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </div>
              {/* Info */}
              <div className="p-5 border border-t-0 border-zinc-100 rounded-b-2xl">
                <span className="text-accent text-xs font-semibold uppercase tracking-wider">{p.category}</span>
                <h3 className="font-heading font-bold text-zinc-900 mt-1 mb-2">{p.title}</h3>
                <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-emerald-700 bg-emerald-50 px-3 py-1 rounded-full">
                  <i className="ri-arrow-up-line text-xs" />
                  {p.result}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
